export default __webpack_public_path__ + "static/media/production.284f766c.jpeg";